export default {
  common: {
    systemTitle: 'Fruit Purchase Management System',
    confirm: 'Confirm',
    cancel: 'Cancel',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    search: 'Search',
    reset: 'Reset',
    back: 'Back',
    loading: 'Loading...',
    noData: 'No Data',
    operation: 'Operation',
    success: 'Success',
    failed: 'Failed',
    export: 'Export',
    import: 'Import',
    view: 'View',
    close: 'Close'
  },
  
  auth: {
    systemTitle: 'Fruit Purchase Management System',
    loginSubtitle: 'Welcome',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    logout: 'Logout',
    loggingIn: 'Logging in...',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    logoutSuccess: 'Logged out',
    logoutConfirm: 'Are you sure to logout?',
    usernameRequired: 'Please enter username',
    passwordRequired: 'Please enter password',
    captcha: 'Captcha',
    captchaRequired: 'Please enter captcha',
    captchaPlaceholder: 'Enter the code shown',
    refreshCaptcha: 'Refresh',
    defaultAccount: 'Default Account',
    initSystem: 'Initialize System'
  },
  
  project: {
    title: 'Purchase Management',
    name: 'Project Name',
    description: 'Description',
    createTime: 'Create Time',
    createProject: 'Create Project',
    editProject: 'Edit Project',
    deleteProject: 'Delete Project',
    enterProject: 'Enter Project',
    projectList: 'Project List',
    projectDetail: 'Project Detail',
    backToList: 'Back to Project List',
    deleteConfirm: 'Are you sure to delete this project? All data under this project will be deleted!',
    purchaseModule: 'Purchase Management',
    shipmentModule: 'Shipment Management',
    selectModule: 'Please select a module to enter'
  },
  
  customer: {
    title: 'Customer Management',
    customerNumber: 'Customer No.',
    price: 'Price (¥/Jin)',
    tareWeight: 'Tare Weight (Jin)',
    createTime: 'Create Time',
    addCustomer: 'Add Customer',
    editCustomer: 'Edit Customer',
    deleteCustomer: 'Delete Customer',
    customerList: 'Customer List',
    deleteConfirm: 'Are you sure to delete this customer? All weighing records of this customer will also be deleted!',
    pricePerJin: '¥/Jin',
    jinPerBasket: 'Jin/Basket',
    recalculate: 'Recalc',
    recalculateConfirm: 'Are you sure to recalculate all weighing records of customer {customerNumber}?',
    editWarning: 'Modifying customer price or tare weight will recalculate all historical weighing records. Continue?',
    recalculateSuccess: 'Recalculation completed',
    noRecords: 'Click to add the first weighing record',
    purchaseManagement: 'Purchase Management'
  },
  
  record: {
    title: 'Weighing Records',
    totalWeight: 'Total Weight (Jin)',
    basketCount: 'Basket Count',
    tareWeight: 'Tare Weight (Jin)',
    netWeight: 'Net Weight (Jin)',
    totalAmount: 'Amount (¥)',
    weighTime: 'Weigh Time',
    remark: 'Remark',
    addRecord: 'Add Weighing Record',
    editRecord: 'Edit Weighing Record',
    deleteRecord: 'Delete Record',
    deleteConfirm: 'Are you sure to delete this record?',
    weigh: 'Weigh',
    recordList: 'Weighing Records',
    recordsByDate: 'Weighing Records (Sorted by Time Desc)',
    currentStats: 'Current Statistics'
  },
  
  shipment: {
    title: 'Shipment Records',
    licensePlate: 'License Plate',
    driverPhone: 'Driver Phone',
    driverName: 'Driver Name',
    receiverPhone: 'Receiver Phone',
    totalWeight: 'Cargo Weight (KG)',
    basketCount: 'Basket Count',
    freightCost: 'Freight Cost',
    basketCost: 'Basket Cost',
    waxingCost: 'Waxing Cost',
    agencyCost: 'Agency Cost',
    otherCost: 'Other Cost',
    totalCost: 'Total Cost',
    costInfo: 'Cost Information',
    shipmentTime: 'Shipment Time',
    destination: 'Destination',
    remark: 'Remark',
    addShipment: 'Add Shipment Record',
    editShipment: 'Edit Shipment Record',
    deleteShipment: 'Delete Shipment Record',
    deleteConfirm: 'Are you sure to delete this shipment record?',
    shipmentList: 'Shipment Record List',
    shipmentManagement: 'Shipment Management',
    viewShipments: 'View Shipment Records',
    cargoInfo: 'Cargo Information',
    cargoName: 'Cargo Name',
    driverInfo: 'Driver Information',
    receiverInfo: 'Receiver Information',
    print: 'Print',
    printPreview: 'Print Preview',
    shipmentReceipt: 'Shipment Receipt',
    printDate: 'Print Date',
    sender: 'Sender',
    receiver: 'Receiver',
    kg: 'KG'
  },
  
  cost: {
    costManagement: 'Cost Management',
    basketCost: 'Basket Cost',
    waxingCost: 'Waxing Cost',
    agencyCost: 'Agency Cost',
    otherCost: 'Other Cost',
    totalCost: 'Total Cost',
    costDetails: 'Cost Details',
    remark: 'Remark',
    editCost: 'Edit Cost',
    noCostRecord: 'No cost record for this shipment',
    deleteConfirm: 'Are you sure to delete this cost record?',
    batchDelete: 'Delete selected',
    batchDeleteConfirm: 'Remove the selected {count} shipment records? Their costs will be removed and they will no longer appear in the list.',
    selectCostFirst: 'Select records to delete first',
    hideConfirm: 'Remove this shipment record? Its cost will be removed and it will no longer appear in the list.'
  },
  
  statistics: {
    title: 'Statistics',
    viewStatistics: 'View Statistics',
    totalRecords: 'Total Records',
    totalBaskets: 'Total Baskets',
    totalTareWeight: 'Total Tare Weight',
    totalNetWeight: 'Total Net Weight',
    totalGrossWeight: 'Total Gross Weight',
    totalAmount: 'Total Amount',
    averagePrice: 'Average Price',
    averageWeight: 'Avg Weight Per Record',
    actualAveragePrice: 'Actual Avg Price',
    customerCount: 'Customer Count',
    customerDetails: 'Customer Statistics Details',
    customerDetailsByDate: 'Customer Statistics Details (Sorted by Create Time Desc)',
    recordCount: 'Record Count',
    firstWeighTime: 'First Weigh',
    lastWeighTime: 'Last Weigh',
    setPrice: 'Set Price',
    projectAvgPrice: 'Project Avg Price',
    times: 'Times',
    baskets: 'Pcs',
    jin: 'Jin',
    yuan: '¥',
    people: 'People'
  },
  
  report: {
    title: 'Data Report',
    dataReport: 'Data Report',
    dataAnalysis: 'Data Report Analysis',
    dateRange: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'To',
    generateReport: 'Generate Report',
    exportExcel: 'Export Excel',
    exporting: 'Exporting...',
    selectDateRange: 'Please select date range',
    useDefaultRange: 'Use Default Date Range',
    dailyTrend: 'Daily Data Trend',
    customerAmountRatio: 'Customer Amount Ratio',
    customerComparison: 'Customer Comparison Analysis',
    topByAmount: 'Top by Amount',
    topByWeight: 'Top by Weight',
    topByRecords: 'Top by Records',
    highestPrice: 'Highest Price',
    lowestPrice: 'Lowest Price',
    customerDetailData: 'Customer Detail Data',
    dailyStatistics: 'Daily Statistics',
    date: 'Date',
    amount: 'Amount',
    weight: 'Weight',
    netWeight: 'Net Weight',
    grossWeight: 'Gross Weight',
    dailyAvgPrice: 'Daily Avg Price',
    overallStats: 'Overall Statistics',
    reportGenerated: 'Report generated successfully',
    reportFailed: 'Report generation failed',
    exportSuccess: 'Excel exported successfully',
    exportFailed: 'Excel export failed',
    noDataPrompt: 'Please select date range and generate report'
  },
  
  message: {
    saveSuccess: 'Saved successfully',
    saveFailed: 'Save failed',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    loadFailed: 'Load failed',
    operationSuccess: 'Operation successful',
    operationFailed: 'Operation failed',
    pleaseSelectDateRange: 'Please select date range',
    pleaseGenerateReport: 'Please generate report data first',
    confirmDelete: 'Confirm Delete',
    warning: 'Warning',
    info: 'Info',
    required: 'Required',
    pleaseInput: 'Please input',
    pleaseSelect: 'Please select'
  }
}
